export default __webpack_public_path__ + "static/new-token-curve-770fc5c5067cb11b806d555521de65cf.svg";